import Vue from 'vue'
import VueRouter from 'vue-router'
import {Dialog} from "vant";

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        redirect: '/home',
        meta: {},
    },
    {
        path: '/wechatAuth/:pathName',
        name: 'wechatAuth',
        meta: {title: "微信授权验证"},
        component: () => import(/* webpackChunkName: "wechatAuth" */ '@/components/WechatAuth')
    },
    {
        path: '/login',
        name: 'login',
        meta: {title: "登录"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/login')
    },
    {
        path: '/forgetPass',
        name: 'forgetPass',
        meta: {title: "重置密码"},
        component: () => import('@/views/forgetPass')
    },
    {
        path: '/register',
        name: 'register',
        meta: {title: "注册"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/register')
    }, {
        path: '/home',
        name: 'home',
        meta: {title: window.g.VUE_APP_HOSPITALNAME},
        component: () => import(/* webpackChunkName: "home" */ '@/views/home')
    }, {
        path: '/package',
        name: 'package',
        meta: {title: "套餐列表"},
        component: () => import(/* webpackChunkName: "package" */ '@/views/package')
    }, {
        path: '/packageDetail',
        name: 'packageDetail',
        meta: {title: "套餐详情",requireAuth:true},
        component: () => import(/* webpackChunkName: "package" */ '@/views/packageDetail')
    }, {
        path: '/checkInfo',
        name: 'checkInfo',
        meta: {title: "检查信息",requireAuth:true},
        component: () => import(/* webpackChunkName: "checkInfo" */ '@/views/checkInfo')
    },//appointment
    {
        path: '/appointment',
        name: 'appointment',
        meta: {title: "预约",requireAuth:true},
        component: () => import(/* webpackChunkName: "appointment" */ '@/views/appointment')
    },
    {
        path: '/orders',
        name: 'orders',
        meta: {title: "订单",requireAuth:true},
        component: () => import(/* webpackChunkName: "orders" */ '@/views/orders')
    },
    {
        path: '/userinfo',
        name: 'userinfo',
        meta: {title: "个人中心",requireAuth:true},
        component: () => import(/* webpackChunkName: "login" */ '@/views/userinfo')
    },
    {
        path: '/questionnaire',
        name: 'questionnaire',
        meta: {title: "问卷调查",requireAuth:true},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/questionnaire')
    },
    {
        path: '/preconsultation',
        name: 'preconsultation',
        meta: {title: "检前问卷",requireAuth:true},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/preconsultation'),
    },
    {
        path: '/preconsultationDetail',
        name: "preconsultationDetail",
        meta: { title: '检前问卷详情',requireAuth:true},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/preconsultationDetail')
    },
    {
        path: '/preconsultationAnswer',
        name: "preconsultationAnswer",
        meta: { title: '问卷答案',requireAuth:true},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/preconsultationAnswer')
    },
    {
        path: '/topic',
        name: 'topic',
        meta: {title: "填写问卷",requireAuth:true},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/topic')
    },
    {
        path:'/psychologicalQuestionnaire',
        name:'psychologicalQuestionnaire',
        meta:{title: "心理问卷"},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/psychologicalQuestionnaire/index.vue')
    },
    {
        path: '/preconsultationDetailQRCode',
        name: 'preconsultationDetailQRCode',
        meta: {title: "检前问卷"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/preconsultationDetailQRCode'),
    },
    {
        path: '/notice',
        name: 'notice',
        meta: {title: "体检须知"},
        component: () => import(/* webpackChunkName: "notice" */ '@/views/notice')
    },
    {
        path: '/queuing',
        name: 'queuing',
        meta: {title: "体检排队",requireAuth:true},
        component: () => import(/* webpackChunkName: "queuing" */ '@/views/queuing')
    },
    {
        path: '/intelligentGuide',
        name: 'intelligentGuide',
        meta: {title: "智能导检"},
        component: () => import(/* webpackChunkName: "queuing" */ '@/views/intelligentGuide')
    },
    {
        path: '/edituser',
        name: 'edituser',
        meta: {title: "编辑用户",requireAuth:true},
        component: () => import(/* webpackChunkName: "login" */ '@/views/edituser')
    },
    {
        path: '/relatives',
        name: 'relatives',
        meta: {title: "家庭成员",requireAuth:true},
        component: () => import(/* webpackChunkName: "relatives" */ '@/views/relatives')
    },
    {
        path: '/about',
        name: 'about',
        meta: {title: "关于我们"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/about')
    },
    {
        path: '/report',
        name: 'report',
        meta: {title: "报告列表",requireAuth:true},
        component: () => import(/* webpackChunkName: "report" */ '@/views/report')
    },
    {
        path: '/reportdetail',
        name: 'reportdetail',
        meta: {title: "报告详情",requireAuth:true},
        component: () => import(/* webpackChunkName: "reportdetail" */ '@/views/reportdetail')
    },
    {
        path: '/reportpdf',
        name: 'reportpdf',
        meta: {title: "PDF报告",requireAuth:true},
        component: () => import(/* webpackChunkName: "reportpdf" */ '@/views/reportpdf')
    },
    {
        path: '/reportdownload',
        name: 'reportdownload',
        meta: {title: "PDF报告下载页"},
        component: () => import(/* webpackChunkName: "reportdownload" */ '@/views/reportdownload')
    },
    {
        path: '/navigation',
        name: 'navigation',
        meta: {title: "交通指引"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/navigation')
    },
    {
        path: '/map',
        name: 'map',
        meta: {title: "科室导航"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/map')
    },
    {
        path: '/companyOrders',
        name: 'companyOrders',
        meta: {title: "单位预约列表",requireAuth:true},
        component: () => import(/* webpackChunkName: "order" */ '@/views/companyOrders')
    },
    {
        path: '/companyOrder',
        name: 'companyOrder',
        meta: {title: "单位预约",requireAuth:true},
        component: () => import(/* webpackChunkName: "order" */ '@/views/companyOrder')
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        meta: {title: "订单详情",requireAuth:true},
        component: () => import(/* webpackChunkName: "order" */ '@/views/orderDetail')
    },
    {
        path: '/student',
        name: 'student',
        meta: {title: "学生体检"},
        component: () => import(/* webpackChunkName: "order" */ '@/views/student')
    },
    {
        path: '/dataview',
        name: 'dataview',
        meta: {title: "历年体检结果",requireAuth:true},
        component: () => import(/* webpackChunkName: "dataview" */ '@/views/dataview')
    },
    {
        path: '/survey',
        name: 'survey',
        meta: {title: "满意度调查"},
        component: () => import(/* webpackChunkName: "questionnaire" */ '@/views/survey')
    },
    {
        path: '/payDetail',
        name: 'payDetail',
        meta: {title: "订单详情"},
        component: () => import(/* webpackChunkName: "order" */ '@/views/payDetail')
    },
    {
        path: '/wxPay',
        name: 'wxPay',
        meta: {title: "支付"},
        component: () => import(/* webpackChunkName: "pay" */ '@/views/wxPay')
    },
    {
        path: '/jumpMpApp',
        name: 'jumpMpApp',
        meta: {title: "跳转小程序支付"},
        component: () => import(/* webpackChunkName: "pay" */ '@/views/jumpMpApp')
    },
    {
        path:'/recharge',
        name:'recharge',
        meta:{title: "付款中...",requireAuth:true},
        component: () => import(/* webpackChunkName: "pay" */ '@/views/recharge')
    },
    {
        path:'/testWechatPay',
        name:'testWechatPay',
        meta:{title: "测试微信支付"},
        component: () => import(/* webpackChunkName: "pay" */ '@/views/testWechatPayV3Utils')
    },
    {
        path:'/orderDateUpdate',
        name:'orderDateUpdate',
        meta:{title: "个人更改预约日期",requireAuth:true},
        component: () => import(/* webpackChunkName: "order" */ '@/views/orderDateUpdate')
    },
    {
        path:'/companyOrderUpdateDate',
        name:'companyOrderUpdateDate',
        meta:{title: "单位更改预约日期",requireAuth:true},
        component: () => import(/* webpackChunkName: "order" */ '@/views/companyOrderUpdateDate')
    },
    {
        path:'/letterConsent',
        name:'letterConsent',
        meta:{title: "待办任务"},
        component: () => import(/* webpackChunkName: "letterConsent" */ '@/views/letterConsent/index.vue')
    },
    {
        path:'/letterConsentForm',
        name:'letterConsentForm',
        meta:{title: "知情同意书"},
        component: () => import(/* webpackChunkName: "order" */ '@/views/letterConsentForm/index.vue')
    },
    {
        path:'/letterConsentPreview',
        name:'letterConsentPreview',
        meta:{title: "知情同意书"},
        component: () => import(/* webpackChunkName: "order" */ '@/views/letterConsentPreview/index.vue')
    },
    {
        path:'/parkingTicket',
        name:'parkingTicket',
        meta:{title: "车牌"},
        component: () => import(/* webpackChunkName: "parkingTicket" */ '@/views/parkingTicket/index.vue')
    },

    {
        path:'/healthCertificateList',
        name:'healthCertificateList',
        meta:{title: "健康证"},
        component: () => import(/* webpackChunkName: "healthCertificateList" */ '@/views/healthCertificateList/index.vue')
    },
    {
        path:'/healthCertificateInfo',
        name:'healthCertificateInfo',
        meta:{title: "健康证"},
        component: () => import(/* webpackChunkName: "healthCertificateList" */ '@/views/healthCertificateInfo/index.vue')
    },
    {
        path:'/message',
        name:'message',
        meta:{title: "健康科普"},
        component: () => import(/* webpackChunkName: "message" */ '@/views/message/index.vue')
    },
    {
        path:'/messageDetail',
        name:'messageDetail',
        meta:{title: "健康科普"},
        component: () => import(/* webpackChunkName: "message" */ '@/views/message/detail.vue')
    },

    {
        path: '/referralCode',
        name: 'referralCode',
        meta: {title: "分享推荐码"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/referralCode/index.vue'),
    },
    {
        path: '/cloudFilmGZLFE',
        name: 'cloudFilmGZLFE',
        meta: {title: "云影像"},
        component: () => import(/* webpackChunkName: "login" */ '@/views/cloudFilmGZLFE/index.vue'),
    }

]
const router = new VueRouter({
    routes
})
let param_code = ""
router.beforeEach((to, from, next) => {
    //登录用户信息
    let loginuser = JSON.parse(localStorage.getItem("loginuser"));
    if (to.meta.requireAuth && loginuser == null) {
        localStorage.setItem("topath", to.path)
        localStorage.setItem("toquery", JSON.stringify(to.query))
        console.log("跳转的路径",to.path+'?',to.query)
        if (window.g.VUE_APP_ISWECHAT == '1' && "home_url_param_openId" != window.g.VUE_APP_GET_OPENID_TYPE) {
            next('/wechatAuth/' + to.name);
        }
        else{
            if(to.path=='/login'||to.path=='/'){ //如果是登录页面路径，就直接next()
                next();
            } else { //不然就跳转到登录；
                console.log("to.path",to.path)
                next('/login');
            }
        }
    }

    let disableMenuArr = window.g.VUE_APP_MENU_DISABLE
    if(disableMenuArr.includes(to.name)){
        Dialog.alert({
            message: '该功能未开放',
        }).then(() => {
            // on close
        });
        return
    }
    console.log("meta",to.meta.title)
    if (to.meta.title) {
        document.title = to.meta.title
        console.log("document",document.title)
    }

    next()
})

export default router
